export default __webpack_public_path__ + "static/media/textLogo.3b841e1f.png";